import { createSlice } from '@reduxjs/toolkit';
import { addFoodItem, fetchAllFoodItems, updateFoodItem } from './foodItemsThunk';
import { API_STATUS_TYPE } from '../../../utils/contants';

const INITAL_STATE = {
  isLoading: false,
  foodItems: null,
  currentFoodItem: null,
  status: 'idle',
  error: null
};

const foodItemsSlice = createSlice({
  name: 'FOOD_ITEMS',
  initialState: INITAL_STATE,
  reducers: {
    setCurrentFoodItem: (state, action) => {
        state.currentFoodItem = action.payload
    } ,
    clearFoodItem: (state, action) => {
        state.currentFoodItem = null
    }
  },
  extraReducers: (builder) => {
    builder

      //Adding food Items
      .addCase(addFoodItem.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(addFoodItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      //Fetching food Items
      .addCase(fetchAllFoodItems.pending, (state, action) => {
        state.isLoading = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(fetchAllFoodItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.foodItems = action.payload.data.map((item) => ({
          ...item,
          translationsMap: Array.isArray(item.translations)
            ? item.translations.reduce((acc, t) => {
                if (t && t.languageCode) {
                  acc[t.languageCode] = {
                    name: t.name ?? '',
                    description: t.description ?? ''
                  };
                }
                return acc;
              }, {})
            : {}
        }));
      })
      //Updating food item
      .addCase(updateFoodItem.pending, (state, action)=>{
        state.status = API_STATUS_TYPE.PENDING
        state.isLoading = true
      })
      .addCase(updateFoodItem.fulfilled, (state, action)=>{
        state.status = API_STATUS_TYPE.SUCCESSED
        state.isLoading = false
      })

       // Rejected Matcher
      .addMatcher(
        (action) => action.type.startsWith('foodSection/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.isLoading = false;
          state.status = API_STATUS_TYPE.FAILED;
          state.error = action?.payload || 'An unexpected error occurred';
        }
      );
  }
});
export const { setCurrentFoodItem, clearFoodItem } = foodItemsSlice.actions;
export default foodItemsSlice.reducer;
